import React from 'react';
import PropTypes from 'prop-types';

import {QRCodeCanvas} from 'qrcode.react';
import {Avatar, Typography} from 'antd';
import {UserOutlined} from '@ant-design/icons';

import logoImg from '@/asset/logo/abbv-page.png';
import {URL_ROOT} from '@/env';

QrCodeView.propTypes = {
    data: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    size: PropTypes.number,
    iconSize: PropTypes.number,
};

function QrCodeView({data, title, subTitle, size = 300, iconSize = 48}) {
    // 获取当前日期
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // 月份从0开始，所以+1

    // 计算显示的年份：当年11-12月 或 次年1-2月，显示明年年份
    let displayYear;
    if (currentMonth >= 11 || currentMonth <= 2) {
        displayYear = currentMonth <= 2 ? currentYear : currentYear + 1;
    } else {
        displayYear = currentYear;
    }

    return (
        <div style={{width: size}}>
            <div style={{fontSize: '24px', paddingBottom: '12px'}}>
                {/* {displayYear}年艾伯维中国年会 */}
            </div>
            <div style={{display: 'flex', gap: 16, marginBottom: 36}}>
                {/* <Avatar src={require('@/asset/user.jpg').default} shape="square" size={48} /> */}
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <Typography.Title level={5} style={{marginBottom: 0}}>
                        {title}
                    </Typography.Title>
                    <Typography.Text type="secondary">{subTitle}</Typography.Text>
                </div>
            </div>
            <QRCodeCanvas
                size={size}
                value={data}
                imageSettings={{src: logoImg, width: iconSize, height: iconSize}}
            />
        </div>
    );
}

export default QrCodeView;
